export function buildStoreRedirectURLForApp(
  partnerId: string,
  marketId: string,
  appId: string,
  editionId?: string,
  addonId?: string,
): string {
  const storeParams = new URLSearchParams({ appId, partnerId, marketId });
  if (editionId) {
    storeParams.set('editionId', editionId);
  } else if (addonId) {
    storeParams.set('addonId', addonId);
  }
  storeParams.set('redirectOrigin', 'public_store');
  return `/account/location/default/review-cart?${storeParams.toString()}`;
}

export function buildStoreRedirectURLForPackage(
  marketId: string,
  packageId: string,
  redirectOrigin = 'public_store',
): string {
  const storeParams = new URLSearchParams({
    marketId,
    packageId,
    redirectOrigin: redirectOrigin,
  });
  return `/account/location/default/review-cart?${storeParams.toString()}`;
}
